var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessListings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3638 0.76001H11.3698L11.7448 4.51001C11.7448 4.51001 12.4948 5.26001 13.6198 5.26001C14.2103 5.26079 14.7808 5.04582 15.224 4.65551C15.2708 4.61173 15.3058 4.55673 15.3254 4.49571C15.3451 4.43469 15.3489 4.36966 15.3365 4.30676L14.807 1.13501C14.7893 1.03023 14.7351 0.935099 14.6539 0.866464C14.5728 0.797828 14.47 0.760117 14.3638 0.76001V0.76001Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3698 0.76001L11.7448 4.51001C11.7448 4.51001 10.9948 5.26001 9.86975 5.26001C8.74475 5.26001 7.99475 4.51001 7.99475 4.51001V0.76001H11.3698Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99475 0.76001V4.51001C7.99475 4.51001 7.24475 5.26001 6.11975 5.26001C4.99475 5.26001 4.24475 4.51001 4.24475 4.51001L4.61975 0.76001H7.99475Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61976 0.76001H1.62651C1.52 0.75997 1.41694 0.797707 1.33564 0.866508C1.25434 0.935309 1.20008 1.03072 1.18251 1.13576L0.653758 4.30751C0.6414 4.37041 0.645242 4.43542 0.664922 4.49643C0.684602 4.55744 0.719473 4.61244 0.766258 4.65626C1.01226 4.87376 1.56201 5.26076 2.36976 5.26076C3.49476 5.26076 4.24476 4.51076 4.24476 4.51076L4.61976 0.76076V0.76001Z",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 5.26001V12.76C1.25 13.1578 1.40804 13.5394 1.68934 13.8207C1.97064 14.102 2.35218 14.26 2.75 14.26H13.25C13.6478 14.26 14.0294 14.102 14.3107 13.8207C14.592 13.5394 14.75 13.1578 14.75 12.76V5.26001",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1248 14.26V9.76001C10.1248 9.36219 9.96672 8.98065 9.68542 8.69935C9.40411 8.41805 9.02258 8.26001 8.62476 8.26001H7.12476C6.72693 8.26001 6.3454 8.41805 6.0641 8.69935C5.78279 8.98065 5.62476 9.36219 5.62476 9.76001V14.26",
    stroke: "white",
    strokeMiterlimit: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessListings);
export default __webpack_public_path__ + "static/media/Business Listings.4e92569e7dd918128c9a76b55dca4474.svg";
export { ForwardRef as ReactComponent };